import React, { useEffect } from "react";

import './App.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Index from "./views";
import AboutUs from "./views/legal/AboutUs";
import PrivacyPolicy from "./views/legal/PrivacyPolicy";
import CookiePolicy from "./views/legal/CookiePolicy";
import TermsAndConditions from "./views/legal/TermsAndConditions";
import Disclaimer from "./views/legal/Disclaimer";
import Benefits from "./views/sales/Benefits";
import EndUserLicenseAgreement from "./views/legal/EndUserLicencseAgreement";
import AcceptableUsePolicy from "./views/legal/AcceptableUsePolicy";
import PlansAndPricing from "./views/sales/PlansAndPricing";
import SignIn from "./views/user/SignIn";
import PasswordReset from "./views/user/PasswordReset";
import PasswordResetRequestConfirmation from "./views/user/PasswordResetRequestConfirmation";
import RegisterSingle from "./views/sales/RegisterSingle";
import RegisterMulti from "./views/sales/RegisterMulti";
import RegisterBilling from "./views/sales/RegisterBilling";
import RegistrationComplete from "./views/sales/RegistrationComplete";
import RegistrationVerification from "./views/sales/RegistrationVerification";
import EmailConfirmationVerification from "./views/sales/EmailConfirmationVerification";
import SendEmailVerificationEmail from "./views/user/SendEmailVerificationEmail";
import YourProfile from "./views/user/YourProfile";
import YourPreferencesSongBooks from "./views/user/YourPreferencesSongBooks";
import YourPreferencesThemes from "./views/user/YourPreferencesThemes";
import BillingDetails from "./views/user/BillingDetails";
import YourSavedPlaylists from "./views/user/YourSavedPlaylists";
import YourPlaylist from "./views/user/YourPlaylist";
import SignOut from "./views/user/SignOut";
import Help from "./views/help/Help";
import ChooseSongBooks from "./views/songbooks/ChooseSongBooks";
import ChooseScripturePassages from "./views/scripture/ChooseScripturePassages";
import ScripturePackageSongs from "./views/scripture/ScripturePassageSongs";
import CuratedSongsPicker from "./views/CuratedSongsPicker";
import ChooseThemes from "./views/themes/ChooseThemes";
import ThemesSongs from "./views/themes/ThemesSongs";
import ChooseLectionary from "./views/lectionary/ChooseLectionary";
import ContactUs from "./views/ContactUs";
import SubscriptionCancelled from "./views/user/SubscriptionCancelled";
import RegistrationSuccessful from "./views/sales/RegistrationSuccessful";
import RegistrationFailed from "./views/sales/RegistrationFailed";
import CreatingYourFirstSongFlowHelp from "./views/help/CreatingYourFirstSongFlowHelp";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";
import PaymentSelection from "./views/sales/PaymentSelection";
import SignInHelp from "./views/help/SignInHelp";
import HowToRegisterHelp from "./views/help/HowToRegisterHelp";
import CreateACuratedSongFlowFromScriptureHelp from "./views/help/CreateACuratedSongFlowFromScriptureHelp";
import CreateACuratedSongFlowFromThemesHelp from "./views/help/CreateACuratedSongFlowFromThemesHelp";
import HowToReorderACuratedSongFlow from "./views/help/HowToReorderACuratedSongFlowHelp";
import HowToAddAdditionalSongsToAnExistingSongFlowHelp
    from "./views/help/HowToAddAdditionalSongsToAnExistingSongFlowHelp";
import HowToViewYourSavedSongFlowsHelp from "./views/help/HowToViewYourSavedSongFlowsHelp";
import HowToSetUpAndManagePreferredSongBooksHelp from "./views/help/HowToSetUpAndManagePreferredSongBooksHelp";
import HowToSetUpAndManagePreferredThemesHelp from "./views/help/HowToSetUpAndManagePreferredThemesHelp";
import HowToResetYourPasswordHelp from "./views/help/HowToResetYourPasswordHelp";
import CreateACuratedSongFlowFromAThemeHelp from "./views/help/CreateACuratedSongFlowFromAThemeHelp";
import CreateACuratedSongFlowFromALectionaryHelp from "./views/help/CreateACuratedSongFlowFromALectionaryHelp";
import SavingAndManagingYourSongFlowsHelp from "./views/help/SavingAndManagingYourSongFlowsHelp";
import SharingASongFlowHelp from "./views/help/SharingASongFlowHelp";
import AddingSongsFromMultipleSourcesHelp from "./views/help/AddingSongsFromMultipleSourcesHelp";
import ReorderingSongsInYourSongFlowHelp from "./views/help/ReorderingSongsInYourSongFlowHelp";
import LectionaryReadings from "./views/lectionary/LectionaryReadings";
import LectionaryDates from "./views/lectionary/LectionaryDates";
import AdminMenu from "./views/admin/AdminMenu";
import AdminSongs from "./views/admin/AdminSongs";
import AdminSongDuplicates from "./views/admin/AdminSongDuplicates";
import AdminSongDetail from "./views/admin/AdminSongDetail";
import AdminThemes from "./views/admin/AdminThemes";
import AdminMembers from "./views/admin/AdminMembers";
import AdminThemeDetail from "./views/admin/AdminThemeDetail";
import AdminAuthors from "./views/admin/AdminAuthors";
import AdminAuthorDetail from "./views/admin/AdminAuthorDetail";
import AdminImport from "./views/admin/AdminImport";
import AdminOperations from "./views/admin/AdminOperations";
import AdminAccountDetail from "./views/admin/AdminAccountDetail";
import AdminServicePlanTemplates from "./views/admin/AdminServicePlanTemplates";
import AdminServicePlanTemplateDetail from "./views/admin/AdminServicePlanTemplateDetail";
import AdminCuratedSongFlows from "./views/admin/AdminCuratedSongFlows";
import AdminCuratedSongFlowDetail from "./views/admin/AdminCuratedSongFlowDetail";
import PublicSongFlow from "./views/public/PublicSongFlow";
import PublicSongFlowSubscribe from "./views/public/PublicSongFlowSubscribe";
import PublicSongFlowSubscribeGeneral from "./views/public/PublicSongFlowSubscribeGeneral";
import PublicSongFlowUnsubscribe from "./views/public/PublicSongFlowUnsubscribe";
import AdminSongBooks from "./views/admin/AdminSongBooks";
import AdminSongBookDetail from "./views/admin/AdminSongBookDetail";
import IWantToWorship from "./views/marketing/IWantToWorship";
import WorshipHub from "./views/marketing/WorshipHub";
import WorshipSongsByScripture from "./views/marketing/WorshipSongsByScripture";
import HelpCreatingAWorshipList from "./views/marketing/HelpCreatingAWorshipList";
import WorshipPlanningUsingTheLectionary from "./views/marketing/WorshipPlanningUsingTheLectionary";
import PlanWorshipForSunday from "./views/marketing/PlanWorshipForSunday";
import SearchBySong from "./views/song/SearchBySong";
import Security from "./views/legal/Security";
import QrCampaignGenerator from "./views/admin/QrCampaignGenerator";
import QrCampaignList from "./views/admin/QrCampaignList";
import QrCampaignEdit from "./views/admin/QrCampaignEdit";
import ScriptureSongsIndex from "./views/seo/ScriptureSongsIndex";
import ScriptureSongsPage from "./views/seo/ScriptureSongsPage";
import NextSteps from "./views/user/NextSteps";
import ScrollToTop from "./components/helpers/ScrollToTop";
import ScriptureBookPage from "./views/seo/ScriptureBookPage";
import ScriptureChapterPage from "./views/seo/ScriptureChapterPage";
import ThemeSongsIndex from "./views/seo/ThemeSongsIndex";
import ThemeSongsPage from "./views/seo/ThemeSongsPage";
import AuthorSongsIndex from "./views/seo/AuthorSongsIndex";
import AuthorPageRouter from "./views/seo/AuthorPageRouter";
import AuthorSongsPage from "./views/seo/AuthorSongsPage";
import AcceptInvite from "./views/invite/AcceptInvite";
import RegisterForInvite from "./views/invite/RegisterForInvite";
import TeamAccount from "./views/user/TeamAccount";
import RegisterTeam from "./views/sales/RegisterTeam";
import TeamUpgrade from "./views/user/TeamUpgrade";
import RegisterEnterprise from "./views/sales/RegisterEnterprise";
import EnterpriseUpgrade from "./views/user/EnterpriseUpgrade";
import NotFound from "./views/errors/NotFound";
import MyTemplates from "./views/user/MyTemplates";

function App() {
    useEffect(() => {
        const handleInstalled = () => {
            if (typeof window.gtag === 'function') {
                window.gtag("event", "pwa_installed");
            }
            console.log("PWA installed");
        };

        const handler = (e) => {
            e.preventDefault();
            window.__TWB_INSTALL_PROMPT__ = e;
            console.log("Global install event stored");
        };

        window.addEventListener("beforeinstallprompt", handler);
        window.addEventListener("appinstalled", handleInstalled);

        return () => {
            window.removeEventListener("beforeinstallprompt", handler);
            window.removeEventListener("appinstalled", handleInstalled);
        };
    }, []);

    const host = window.location.hostname;

    if (
        host === 'localhost' ||
        host.includes('staging')
    ) {
        window.__DEBUG__ = true;
    }

    return (
      <GoogleReCaptchaProvider
          reCaptchaKey="6LfJ8gMrAAAAAFkNt3QtdHnEkXg7m5Qas5lzEsUW"   // ✅ Replace with your reCAPTCHA site key
          language="en"
          scriptProps={{ async: true, defer: true }}
      >
          <BrowserRouter>
              <ScrollToTop />

              <div>
                {/*<Header />*/}
              <Routes>
                  <Route path="/" element={<Index />} />
                  {/*<Route path="/cliff-festival" element={<CliffFestivalLanding />} />*/}
                  {/*<Route path="/cliff-festival/register/choose-your-plan" exact element={<PaymentSelection />} />*/}
                  {/*<Route path="/cliff-festival/register/single/monthly" exact element={<RegisterSingle />} />*/}
                  {/*<Route path="/cliff-festival/register/single/annually" exact element={<RegisterSingle />} />*/}
                  <Route path="/about-us" exact element={<AboutUs />} />
                  <Route path="/contact-us" exact element={<ContactUs />} />
                  <Route path="/privacy-policy" exact element={<PrivacyPolicy />} />
                  <Route path="/cookie-policy" exact element={<CookiePolicy />} />
                  <Route path="/terms-and-conditions" exact element={<TermsAndConditions />} />
                  <Route path="/disclaimer" exact element={<Disclaimer />} />
                  <Route path="/benefits" exact element={<Benefits />} />
                  <Route path="/security" exact element={<Security />} />
                  <Route path="/end-user-license-agreement" exact element={<EndUserLicenseAgreement />} />
                  <Route path="/acceptable-use-policy" exact element={<AcceptableUsePolicy />} />
                  <Route path="/plans-and-pricing" exact element={<PlansAndPricing />} />
                  <Route path="/sign-in" exact element={<SignIn />} />
                  <Route path="/next-steps" exact element={<NextSteps />} />
                  <Route path="/password/reset/request" exact element={<PasswordReset />} />
                  <Route path="/user/:userId/password/reset/:resetCode" exact element={<PasswordResetRequestConfirmation />} />
                  <Route path="/register/choose-your-plan" exact element={<PaymentSelection />} />
                  <Route path="/register/single/monthly" exact element={<RegisterSingle />} />
                  <Route path="/register/single/annually" exact element={<RegisterSingle />} />
                  <Route path="/register/team/annually" exact element={<RegisterTeam />} />
                  <Route path="/register/multi" exact element={<RegisterMulti />} />
                  <Route path="/register/enterprise" exact element={<RegisterEnterprise />} />
                  <Route path="/register/billing" exact element={<RegisterBilling />} />
                  <Route path="/register/complete" exact element={<RegistrationComplete />} />
                  <Route path="/register/successful" exact element={<RegistrationSuccessful />} />
                  <Route path="/register/failed" exact element={<RegistrationFailed />} />
                  <Route path="/register/:id/verification/:code" exact element={<RegistrationVerification />} />
                  <Route path="/user/:id/verification/:code" exact element={<EmailConfirmationVerification />} />
                  <Route path="/email/verify/request" exact element={<SendEmailVerificationEmail />} />
                  <Route path="/your-profile" exact element={<YourProfile />} />
                  <Route path="/your-preferences/song-books" exact element={<YourPreferencesSongBooks />} />
                  <Route path="/your-preferences/themes" exact element={<YourPreferencesThemes />} />
                  <Route path="/your-profile/billing-details" exact element={<BillingDetails />} />
                  <Route path="/your-profile/team" exact element={<TeamAccount />} />
                  <Route path="/your-profile/team/upgrade" exact element={<TeamUpgrade />} />
                  <Route path="/your-profile/enterprise/upgrade" exact element={<EnterpriseUpgrade />} />
                  <Route path="/my/templates" exact element={<MyTemplates />} />
                  <Route path="/your-profile/subscription-cancelled" exact element={<SubscriptionCancelled />} />
                  <Route path="/your-profile/saved-song-flows" exact element={<YourSavedPlaylists />} />
                  <Route path="/playlist/:id/:name" exact element={<YourPlaylist />} />
                  <Route path="/sign-out" exact element={<SignOut />} />
                  <Route path="/help" exact element={<Help />} />
                  <Route path="/help/how-to-register" exact element={<HowToRegisterHelp />} />
                  <Route path="/help/how-to-sign-in" exact element={<SignInHelp />} />
                  <Route path="/help/creating-your-first-curated-song-flow" exact element={<CreatingYourFirstSongFlowHelp />} />
                  <Route path="/help/create-a-curated-song-flow-from-scripture" exact element={<CreateACuratedSongFlowFromScriptureHelp />} />
                  <Route path="/help/create-a-curated-song-flow-from-themes" exact element={<CreateACuratedSongFlowFromThemesHelp />} />
                  <Route path="/help/how-to-reorder-a-curated-song-flow" exact element={<HowToReorderACuratedSongFlow />} />
                  <Route path="/help/how-to-add-additional-songs-to-an-existing-song-flow" exact element={<HowToAddAdditionalSongsToAnExistingSongFlowHelp />} />
                  <Route path="/help/how-to-view-your-saved-song-flows" exact element={<HowToViewYourSavedSongFlowsHelp />} />
                  <Route path="/help/how-to-set-up-and-manage-preferred-song-books" exact element={<HowToSetUpAndManagePreferredSongBooksHelp />} />
                  <Route path="/help/how-to-set-up-and-manage-preferred-themes" exact element={<HowToSetUpAndManagePreferredThemesHelp />} />
                  <Route path="/help/how-to-reset-your-password" exact element={<HowToResetYourPasswordHelp />} />
                  <Route path="/help/create-a-curated-song-flow-from-a-theme" exact element={<CreateACuratedSongFlowFromAThemeHelp />} />
                  <Route path="/help/create-a-curated-song-flow-from-a-lectionary" exact element={<CreateACuratedSongFlowFromALectionaryHelp />} />
                  <Route path="/help/saving-and-managing-your-song-flows" exact element={<SavingAndManagingYourSongFlowsHelp />} />
                  <Route path="/help/sharing-a-song-flow" exact element={<SharingASongFlowHelp />} />
                  <Route path="/help/adding-songs-from-multiple-sources" exact element={<AddingSongsFromMultipleSourcesHelp />} />
                  <Route path="/help/reordering-songs-in-your-song-flow" exact element={<ReorderingSongsInYourSongFlowHelp />} />
                  <Route path="/scripture/choose-song-book" exact element={<ChooseSongBooks />} />
                  <Route path="/scripture/choose-passages" exact element={<ChooseScripturePassages />} />
                  <Route path="/scripture/songs" exact element={<ScripturePackageSongs />} />
                  <Route path="/scripture/curated-songs" exact element={<CuratedSongsPicker />} />
                  <Route path="/themes/choose-song-book" exact element={<ChooseSongBooks />} />
                  <Route path="/themes/choose-themes" exact element={<ChooseThemes />} />
                  <Route path="/themes/songs" exact element={<ThemesSongs />} />
                  <Route path="/themes/curated-songs" exact element={<CuratedSongsPicker />} />
                  <Route path="/lectionary/choose-lectionary" exact element={<ChooseLectionary />} />
                  <Route path="/lectionary/choose-date" exact element={<LectionaryDates />} />
                  <Route path="/lectionary/readings" exact element={<LectionaryReadings />} />
                  <Route path="/lectionary/choose-song-book" exact element={<ChooseSongBooks />} />
                  <Route path="/lectionary/curated-songs" exact element={<CuratedSongsPicker />} />

                  <Route path="/songs/search" exact element={<SearchBySong />} />
                  <Route path="/invite/:token" exact element={<AcceptInvite />} />
                  <Route path="/register/invite/:token" exact element={<RegisterForInvite />} />
                  <Route path="/admin" exact element={<AdminMenu />} />
                  <Route path="/admin/songs" exact element={<AdminSongs />} />
                  <Route path="/admin/song-duplicates" exact element={<AdminSongDuplicates />} />
                  <Route path="/admin/song/:id" element={<AdminSongDetail />} />
                  <Route path="/admin/themes" exact element={<AdminThemes />} />
                  <Route path="/admin/members" exact element={<AdminMembers />} />
                  <Route path="/admin/theme/:themeId" element={<AdminThemeDetail />} />
                  <Route path="/admin/authors" exact element={<AdminAuthors />} />
                  <Route path="/admin/author/:authorId" element={<AdminAuthorDetail />} />
                  <Route path="/admin/import" element={<AdminImport />} />
                  <Route path="/admin/operations" element={<AdminOperations />} />
                  <Route path="/admin/operations/account/:accountId" element={<AdminAccountDetail />} />
                  <Route path="/admin/song-books" exact element={<AdminSongBooks />} />
                  <Route path="/admin/song-book/:songBookId" element={<AdminSongBookDetail />} />
                  <Route path="/admin/service-plan-templates" exact element={<AdminServicePlanTemplates />} />
                  <Route path="/admin/service-plan-templates/:templateId" element={<AdminServicePlanTemplateDetail />} />
                  <Route path="/admin/curated-song-flows" exact element={<AdminCuratedSongFlows />} />
                  <Route path="/admin/curated-song-flows/:playlistId" element={<AdminCuratedSongFlowDetail />} />
                  <Route path="/song-flows/subscribe" exact element={<PublicSongFlowSubscribeGeneral />} />
                  <Route path="/song-flows/:slug" exact element={<PublicSongFlow />} />
                  <Route path="/song-flows/:slug/subscribe" exact element={<PublicSongFlowSubscribe />} />
                  <Route path="/song-flows/unsubscribe/:token" exact element={<PublicSongFlowUnsubscribe />} />
                  <Route path="/admin/marketing" element={<QrCampaignList />} />
                  <Route path="/admin/marketing/create" element={<QrCampaignGenerator />} />
                  <Route path="/admin/marketing/edit/:id" element={<QrCampaignEdit />} />

                  <Route path="/songs" element={<ScriptureSongsIndex />} />
                  <Route path="/songs/:book" element={<ScriptureBookPage />} />
                  <Route path="/songs/:book/:chapter" element={<ScriptureChapterPage />} />
                  <Route path="/songs/:book/:chapter/:verse" element={<ScriptureSongsPage />} />
                  <Route path="/songs/:book/:chapter/:range" element={<ScriptureSongsPage />} />

                  <Route path="/themes" element={<ThemeSongsIndex />} />
                  <Route path="/themes/:themeId/:slug" element={<ThemeSongsPage />} />
                  <Route path="/themes/:themeId" element={<ThemeSongsPage />} />

                  <Route path="/authors" element={<AuthorSongsIndex />} />
                  <Route path="/authors/:authorId/:slug" element={<AuthorSongsPage />} />
                  <Route path="/authors/:segment" element={<AuthorPageRouter />} />

                  <Route
                      path="/start"
                      element={<IWantToWorship />}
                  />

                  <Route
                      path="/worship"
                      element={<WorshipHub />}
                  />

                  <Route
                      path="/worship/i-want-to-worship"
                      element={<IWantToWorship />}
                  />

                  <Route
                      path="/worship/plan-worship-for-your-next-service"
                      element={<PlanWorshipForSunday />}
                  />

                  <Route
                      path="/worship/worship-songs-by-bible-passage"
                      element={<WorshipSongsByScripture />}
                  />

                  <Route
                      path="/worship/help-creating-a-worship-list"
                      element={<HelpCreatingAWorshipList />}
                  />

                  <Route
                      path="/worship/worship-planning-using-the-lectionary"
                      element={<WorshipPlanningUsingTheLectionary />}
                  />

                  {/*<Route*/}
                  {/*    path="/worship/themes"*/}
                  {/*    element={<WorshipThemes />}*/}
                  {/*/>*/}
                  <Route path="*" element={<NotFound />} />
              </Routes>
              {/*<Footer />*/}
            </div>
          </BrowserRouter>
      </GoogleReCaptchaProvider>
  );
}

export default App;
